import { AlertTriangle, CalendarClock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTaskDashboard } from "@/contexts/TaskDashboardContext";
import type { TaskFilter } from "@/hooks/useWorkspaceTasks";

interface TaskReminderBannersProps {
  onFilterChange: (filter: TaskFilter) => void;
}

export function TaskReminderBanners({ onFilterChange }: TaskReminderBannersProps) {
  const { counts } = useTaskDashboard();

  if (counts.overdue > 0) {
    return (
      <div className="flex items-center justify-between gap-3 rounded-lg border border-destructive/40 bg-destructive/10 px-4 py-3">
        <div className="flex items-start gap-2 min-w-0">
          <AlertTriangle className="h-5 w-5 text-destructive shrink-0 mt-0.5" />
          <div>
            <p className="text-sm font-medium text-destructive">
              {counts.overdue === 1
                ? "1 tarefa atrasada"
                : `${counts.overdue} tarefas atrasadas`}
            </p>
            <p className="text-xs text-muted-foreground">
              Resolva agora para não acumular pendências.
            </p>
          </div>
        </div>
        <Button
          size="sm"
          variant="destructive"
          className="shrink-0"
          onClick={() => onFilterChange("overdue")}
        >
          Ver atrasadas
        </Button>
      </div>
    );
  }

  if (counts.approaching > 0) {
    return (
      <div className="flex items-center justify-between gap-3 rounded-lg border border-amber-500/30 bg-amber-500/10 px-4 py-3">
        <div className="flex items-start gap-2 min-w-0">
          <CalendarClock className="h-5 w-5 text-amber-600 shrink-0 mt-0.5" />
          <p className="text-sm text-amber-900 dark:text-amber-200">
            {counts.approaching === 1
              ? "1 tarefa chegando em breve"
              : `${counts.approaching} tarefas nos próximos dias`}
          </p>
        </div>
        <Button
          size="sm"
          variant="outline"
          className="shrink-0 border-amber-500/50"
          onClick={() => onFilterChange("upcoming")}
        >
          Ver futuras
        </Button>
      </div>
    );
  }

  return null;
}
